import React, { useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import { handleSlider } from '../../../../utils/UiBuilderUtils';
import './Large-Image-Carousal-With-Background.scss';

const LargeImageCarousalWithBackgroundPreview = (props) => {
  const { config } = props;
  const ref = useRef(null);
  const [additionalTransfrom, setAdditionalTransfrom] = useState(0);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
  };

  const CustomSlider = ({ carouselState }) => {
    let value = 0;
    let carouselItemWidth = 0;
    if (ref?.current) {
      carouselItemWidth = ref?.current?.state?.itemWidth;
      const maxTranslateX = Math.round(
        carouselItemWidth * (ref?.current?.state?.totalItems - ref?.current?.state?.slidesToShow) +
          150,
      );
      value = maxTranslateX / 100;
      handleSlider(config, ref);
    }
    const { transform } = carouselState;
    return (
      <div className='custom-slider'>
        <input
          type='range'
          value={Math.round(Math.abs(transform) / value)}
          max={
            (carouselItemWidth * (carouselState.totalItems - carouselState.slidesToShow) +
              (additionalTransfrom === 150 ? 0 : 150)) /
            value
          }
          onChange={(e) => {
            if (ref?.current?.isAnimationAllowed) {
              ref.current.isAnimationAllowed = false;
            }
            const nextTransform = e.target.value * value;
            const nextSlide = Math.round(nextTransform / carouselItemWidth);
            if (e.target.value === 0 && additionalTransfrom === 150) {
              ref.current.isAnimationAllowed = true;
              setAdditionalTransfrom(0);
            }
            ref?.current?.setState({
              transform: -nextTransform,
              currentSlide: nextSlide,
            });
          }}
          className='custom-slider__input'
        />
      </div>
    );
  };

  return (
    <div className='large-image-carousal'>
      {config?.slides?.length && (
        <div>
          <div className='preview-title-carousal'>
            {config?.imgMain?.titleH2 ? config?.imgMain?.titleH2 : 'H2 Title'}
          </div>
          <div
            className='large-image-carousal-box'
            style={{
              backgroundColor: config?.imgMain.backgroundColor || '#8f8f8f',
            }}
          >
            {!config.imgMain.isVideo && (
              <div
                className={`d-flex align-items-center justify-content-center h-100 main-image-container ${
                  config.imgMain?.shadowOverlay ? 'shadowed-img' : ''
                }`}
                style={
                  config.imgMain.imgURL
                    ? {
                        backgroundImage: 'url(' + ASSET_URL + config?.imgMain?.imgURL + ')',
                        backgroundSize: 'cover',
                      }
                    : {
                        backgroundSize: 'cover',
                      }
                }
              >
                <div
                  className='slide-title'
                  style={config?.imgMain?.imgURL ? { color: 'white' } : { color: 'black' }}
                >
                  {config.imgMain.imgURL ? '' : 'Large Image'}
                </div>
              </div>
            )}
            {config.imgMain.isVideo && (
              <div className={`${config.imgMain?.shadowOverlay ? 'shadowed-img' : ''}`}>
                <div className='video-container main-image-container'>
                  <video
                    style={{
                      width: '100%',
                      height: '120px',
                      objectFit: 'fill',
                      position: 'relative',
                      top: 0,
                      left: 0,
                    }}
                    autoPlay
                    loop={config.imgMain?.loopPlayBack}
                    preload='auto'
                    src={config.imgMain?.videoURL}
                    muted
                  />
                  <div
                    className='slide-title-2a'
                    style={config.imgMain.videoURL ? { color: 'white' } : { color: 'black' }}
                  >
                    {config.imgMain.videoURL ? '' : 'Large Video'}
                  </div>
                </div>
              </div>
            )}
            <Carousel
              ref={ref}
              responsive={responsive}
              autoPlay={true}
              infinite={true}
              arrows={false}
              customButtonGroup={<CustomSlider />}
            >
              {config.slides.map((slide, key) => (
                <>
                  {!slide?.isVideo && (
                    <div className='h-100' key={key} style={{ marginLeft: '10px' }}>
                      <div
                        className={`d-flex image-container justify-content-center align-items-center ${
                          slide?.shadowOverlay ? 'shadowed-img' : ''
                        }`}
                        key={key}
                        style={
                          slide.imgURL
                            ? {
                                backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                                backgroundSize: 'cover',
                              }
                            : {}
                        }
                      >
                        <div className='slide-title'>{slide.imgURL ? '' : 'Image'}</div>
                      </div>
                      <div className='slide-title mt-1 mx-1 mb-3'>
                        {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                      </div>
                    </div>
                  )}
                  {slide?.isVideo && (
                    <div
                      className={`h-100 ${slide?.shadowOverlay ? 'shadowed-img' : ''}`}
                      key={key}
                      style={{ marginLeft: '10px' }}
                    >
                      <div className='video-container-6'>
                        <video
                          style={{
                            width: '60px',
                            height: '90px',
                            objectFit: 'fill',
                            position: 'relative',
                            top: 0,
                            left: 0,
                          }}
                          autoPlay
                          loop={slide?.loopPlayBack}
                          preload='auto'
                          src={slide?.videoURL}
                          muted
                        />
                        <div className='slide-title-6a'>{slide.videoURL ? '' : 'Video'}</div>
                        <div className='slide-title mt-1 mx-1 mb-3'>
                          {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ))}
              {config?.viewAll?.isActive && (
                <div className='h-100' style={{ marginLeft: '10px' }}>
                  <div className='d-flex justify-content-center align-items-center view-all-large-carousel'>
                    <div className='slide-title'>View All</div>
                  </div>
                </div>
              )}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
};

export default LargeImageCarousalWithBackgroundPreview;
